// 사이드바 접힘 애니메이션 상태 — ChatPage 와 LabShell 이 같은 셸 클래스를
// 만들어야 한다. 폭이 움직이는 동안(sideAnimating)은 내용이 잘려 나가고,
// 끝난 뒤(railSettled)에야 레일 정렬(라벨 숨김·가운데)이 적용된다.
// LabShell 이 rail-ready 없이 side-collapsed 만 붙여 접힘 화면이 깨졌던 원인 —
// 셸이 늘어날 때마다 로직을 베끼지 않도록 훅으로 묶었다.
import { useEffect, useState } from "react";

export function useRailSettle(collapsed: boolean) {
  const [railSettled, setRailSettled] = useState(collapsed);
  const [sideAnimating, setSideAnimating] = useState(false);
  useEffect(() => {
    setSideAnimating(true);
    const settle = setTimeout(() => {
      setSideAnimating(false);
      setRailSettled(collapsed);
    }, 280); // CSS transition(260ms)보다 약간 길게
    if (!collapsed) setRailSettled(false); // 펼칠 땐 즉시 라벨 복귀 — 폭이 자라며 드러난다
    return () => clearTimeout(settle);
  }, [collapsed]);
  return { railSettled, sideAnimating };
}

/** 셸 클래스 문자열 — 세 상태의 조합을 한 곳에서 */
export function shellClass(collapsed: boolean, railSettled: boolean, sideAnimating: boolean) {
  return `shell${collapsed ? " side-collapsed" : ""}${railSettled ? " rail-ready" : ""}${
    sideAnimating ? " side-animating" : ""
  }`;
}
